import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormArray, FormGroup } from '@angular/forms';
import { MultiShipmentFormGroup } from '../../model';
import { createDatePickerProfileForm, DatePickerProfileForm } from './date-picker-tab.utils';

@Component({
  selector: 'multi-shipment-date-picker-tab',
  templateUrl: './date-picker-tab.component.html',
  styleUrls: ['./date-picker-tab.component.scss'],
  standalone: false,
})
export class DatePickerTabComponent implements OnInit {
  @Input({ required: true }) formGroup!: FormGroup<MultiShipmentFormGroup>;

  datePickerProfiles!: FormArray<FormGroup<DatePickerProfileForm>>;

  private destroyRef = inject(DestroyRef);
  private isRevalidatingNames = false;

  ngOnInit(): void {
    this.datePickerProfiles = this.formGroup.controls.datePickerProfiles;
    this.datePickerProfiles.valueChanges
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.revalidateProfileNames());
  }

  addProfile(): void {
    const name = `Date picker profile ${this.datePickerProfiles.length + 1}`;
    this.datePickerProfiles.push(createDatePickerProfileForm({ name }));
    this.datePickerProfiles.markAsDirty();
  }

  removeProfile(index: number): void {
    this.datePickerProfiles.removeAt(index);
    this.datePickerProfiles.markAsDirty();
  }

  onProfileDrop(event: CdkDragDrop<unknown>): void {
    if (event.previousIndex === event.currentIndex) {
      return;
    }
    const profile = this.datePickerProfiles.at(event.previousIndex);
    this.datePickerProfiles.removeAt(event.previousIndex);
    this.datePickerProfiles.insert(event.currentIndex, profile);
    this.datePickerProfiles.markAsDirty();
  }

  private revalidateProfileNames(): void {
    if (this.isRevalidatingNames) {
      return;
    }
    this.isRevalidatingNames = true;
    this.datePickerProfiles.controls.forEach((profile) =>
      profile.controls.name.updateValueAndValidity({ emitEvent: false }),
    );
    this.isRevalidatingNames = false;
  }
}
